import { React, useEffect, useState } from "react";
import VideoGroupsBanner from "../../../components/videoGroupsBanner";
import img_murcielago from "../../../assets/images/img_murcielago.png";
import ico_murcielago from "../../../assets/icons/ico_murcielago.svg";
import GroupInfoSection from "../../../components/groupInfoSection";
import GoToPage from "../../../components/goToPage";
import GroupsVideoFooter from "../../../components/groupsVideoFooter";
const BatsScreen = ({ handle }) => {
  const [width, setWidth] = useState(window.innerWidth);
  const bosque = "https://drive.google.com/uc?export=download&id=1tIJ6tOcvie2j2X2iOU0YxDypFkzvSFX0";
  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [width]);

  useEffect(() => {
    handle(false);
    return () => handle(true);
  }, [handle]);

  return (
    <div className="bg-[#002E0F] h-full">
      {width > 1300 ? (
        <div>
          <div className="grid lg:grid-cols-2 md:grid-cols-1 sm:grid-cols-1 lg:grid-rows-1  gap-0 w-full h-full bg-[#002E0F] absolute">
            <div className="relative w-full lg:h-full ">
              <VideoGroupsBanner videoSource={bosque} left="32%" />
              <div className="h-full bg-[#002E0F] bottom-0 right-0 absolute z-30 pl-24 pt-10 pr-36">
                <GoToPage
                  page="/grupos"
                  side="left"
                  name="Atrás"
                  fontsize="text-lg"
                  textColor="text-white"
                  borderType="border-b-2"
                  borderColor="border-white"
                  iconSize="h-4"
                  iconColor="invert"
                  iconMargin="mr-5"
                ></GoToPage>
              </div>
              <img
              
                src={img_murcielago}
                alt=""
                className="w-full bottom-0 absolute z-40 pr-36"
              />
            </div>

            <GroupInfoSection
              icon={ico_murcielago}
              title={<p>Murciélagos</p>}
              subTitle=""
              textFirstTab={
                <p>
                  Los murciélagos son el segundo grupo más diverso de mamíferos
                  en el mundo. Cada especie de murciélago tiene una dieta
                  específica: frutas, peces, ranas y algunos, sangre. Por ello y
                  por su capacidad de volar son excelentes especies termómetro o
                  indicadores.
                </p>
              }
              textSecondTab={
                <p>
            Su diversidad en formas, dietas y su capacidad de vuelo los convierte en un grupo representativo de la complejidad del ecosistema en donde se encuentren.                
             </p>
              }
              textThirdTab={
                <p>
                  Con los murciélagos es fácil realizar estudios para monitorear distintos tipos de paisaje como: áreas de cultivo, bosques secundarios, bosques maduros y pastizales. El anochecer y las madrugadas son los mejores momentos para su avistamiento.
                </p>
              }
            ></GroupInfoSection>
          </div>
        </div>
      ) : (
        <div className="min-h-[100vh] grid grid-cols-1 h-full">
          <div className=" bg-[#002E0F] left-0  lg:pl-24 md:pl-10 sm:pl-10 pl-10 pt-32 pr-36 h-fit">
            <GoToPage
              page="/grupos"
              side="left"
              name="Atrás"
              fontsize="text-lg"
              textColor="text-white"
              borderType="border-b-2"
              borderColor="border-white"
              iconSize="h-4"
              iconColor="invert"
              iconMargin="mr-5"
            ></GoToPage>
          </div>
          <div style={{"z-index":"1"}}>
          <GroupInfoSection
              icon={ico_murcielago}
              title={<p>Murciélagos</p>}
              subTitle=""
              textFirstTab={
                <p>
                  Los murciélagos son el segundo grupo más diverso de mamíferos
                  en el mundo. Cada especie de murciélago tiene una dieta
                  específica: frutas, peces, ranas y algunos, sangre. Por ello y
                  por su capacidad de volar son excelentes especies termómetro o
                  indicadores.
                </p>
              }
              textSecondTab={
                <p>
                Su diversidad en formas, dietas y su capacidad de vuelo los convierte en un grupo representativo de la complejidad del ecosistema en donde se encuentren.                
                </p>
              }
              textThirdTab={
                <p>
                  Con los murciélagos es fácil realizar estudios para monitorear distintos tipos de paisaje como: áreas de cultivo, bosques secundarios, bosques maduros y pastizales. El anochecer y las madrugadas son los mejores momentos para su avistamiento.
                </p>
              }
            ></GroupInfoSection>
          </div>
          <div className="relative w-full lg:h-full flex justify-center">
            <GroupsVideoFooter videoSource={bosque} />
           
            <img
            
              src={img_murcielago}
              alt=""
              className="lg:w-[60rem] md:w-[45rem] sm:w-[30rem] w-[20rem] lg:h-[30rem] md:h-[23rem]  sm:h-[15rem] h-[10rem] lg:mb-[13rem] md:mb-[11rem] sm:mb-[12rem] mb-[10rem] bottom-0 absolute "
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default BatsScreen;
